/* KA sponsored teams carousel (D45, D46). The loop itself is pure CSS (track
   translateX 0 to -50%). This file (1) sets each row's duration so every row
   moves at the same px/s and one card crosses the viewport in ~7.5 s,
   (2) pauses off-screen via IntersectionObserver, (3) the section reveal,
   (4) on hover eases every row's playbackRate to a third and back (never 0). */
(function () {
  var CROSS_SECONDS = 7.5;
  var HOVER_RATE = 1 / 3;
  var EASE_MS = 450;
  var roots = document.querySelectorAll('[data-ka-teams]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce) and (min-width: 900px)').matches;

  function setSpeed(root) {
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var pxPerSec = vw / CROSS_SECONDS;
    root.querySelectorAll('[data-ka-track]').forEach(function (track) {
      var half = track.scrollWidth / 2;
      if (half > 0) track.style.setProperty('--ka-teams-dur', (half / pxPerSec).toFixed(2) + 's');
    });
  }

  /* Hover speed. The CSS animation keeps running; its playbackRate is eased
     with a frame loop (WAAPI keeps the position continuous when the rate
     changes), so entering and leaving never jump or stop. */
  function easeOnHover(root) {
    var rows = root.querySelector('.ka-teams__rows');
    var tracks = [].slice.call(root.querySelectorAll('[data-ka-track]'));
    if (!rows || !tracks.length || !tracks[0].getAnimations) return;
    var rate = 1, target = 1, raf = 0, last = 0;
    function apply() {
      tracks.forEach(function (t) {
        t.getAnimations().forEach(function (a) { a.playbackRate = rate; });
      });
    }
    function tick(now) {
      var dt = Math.min(now - last, 50);
      last = now;
      /* exponential approach: about 95% of the way in EASE_MS */
      rate += (target - rate) * (1 - Math.exp(-3 * dt / EASE_MS));
      if (Math.abs(target - rate) < 0.005) rate = target;
      apply();
      raf = rate === target ? 0 : requestAnimationFrame(tick);
    }
    function go(t) {
      target = t;
      if (!raf) { last = performance.now(); raf = requestAnimationFrame(tick); }
    }
    rows.addEventListener('mouseenter', function () { go(HOVER_RATE); });
    rows.addEventListener('mouseleave', function () { go(1); });
  }

  roots.forEach(function (root) {
    setSpeed(root);
    var lastW = document.documentElement.clientWidth;
    window.addEventListener('resize', function () {
      var w = document.documentElement.clientWidth;
      if (w !== lastW) { lastW = w; setSpeed(root); }
    });
    window.addEventListener('load', function () { setSpeed(root); });

    if (!reduce && window.matchMedia('(hover: hover)').matches) easeOnHover(root);

    if (reduce || !('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }
    var revealed = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        root.classList.toggle('is-offscreen', !e.isIntersecting);
        if (e.isIntersecting && !revealed) { revealed = true; root.classList.add('is-in'); }
      });
    }, { threshold: 0.1 });
    io.observe(root);
    /* Reveal failsafe: .is-in after 2 s even if the observer never fires
       (same defect class as ka-comparison.liquid, Klaus 2026-08). */
    setTimeout(function () { root.classList.add('is-in'); }, 2000);
  });
})();
